import { render, staticRenderFns } from "./DetalheField.vue?vue&type=template&id=8709afde"
import script from "./DetalheField.vue?vue&type=script&lang=js"
export * from "./DetalheField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports